// src/components/CareersSection.jsx
import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Button,
  useTheme
} from '@mui/material';
import {
  WhatsApp as WhatsAppIcon,
  Email as EmailIcon
} from '@mui/icons-material';

const WHATSAPP_NUMBER = '94770837053';      // your support WhatsApp (no '+' or dashes)
const HR_EMAIL        = 'lemda.webdev@gmail.com'; // your HR email address

// Expanded list of open roles
const roles = [
  'HR Manager',
  'Receptionist',
  'Customer Care Officer',
  'Web Developer',
  'Graphics Designer',
  'Content Creator',
  'Project Manager',
  'Mobile App Developer',
  'Cleaning Staff',
];

export default function CareersSection() {
  const theme = useTheme();

  const applyViaWhatsApp = (role) => {
    const text = encodeURIComponent(
      `Hello! I’d like to apply for the *${role}* position at Lemda. ` +
      `Could you please advise on the next steps?\n\nThank you!`
    );
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${text}`, '_blank');
  };

  const applyViaEmail = (role) => {
    const subject = encodeURIComponent(`Application for ${role} role`);
    const body = encodeURIComponent(
      `Hello Lemda team,\n\n` +
      `I’m writing to apply for the ${role} position. ` +
      `Here’s a little about me:\n\n- Name: \n- Experience: \n- Portfolio/LinkedIn: \n\n` +
      `Thank you for your consideration.\n`
    );
    window.location.href = `mailto:${HR_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <Box component="section" sx={{ bgcolor: theme.palette.background.paper, py: { xs: 6, md: 10 } }}>
      <Container>
        <Typography variant="h4" align="center" fontWeight={700} gutterBottom>
          Join Our Team
        </Typography>
        <Typography variant="subtitle1" align="center" sx={{ mb: 4, color: theme.palette.text.secondary }}>
          We’re always looking for talented people. Click a role to apply!
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {roles.map((role) => (
            <Grid item xs={12} sm={6} md={4} key={role}>
              <Card
                elevation={3}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  borderRadius: 3
                }}
              >
                <CardContent>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    {role}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Ready to make an impact? Let’s chat about your next opportunity.
                  </Typography>
                </CardContent>

                <Box
                  sx={{
                    p: 2,
                    pt: 0,
                    display: 'flex',
                    gap: 1,
                    justifyContent: 'center'
                  }}
                >
                  <Button
                    startIcon={<WhatsAppIcon />}
                    variant="outlined"
                    color="success"
                    fullWidth
                    onClick={() => applyViaWhatsApp(role)}
                    sx={{ textTransform: 'none' }}
                  >
                    WhatsApp
                  </Button>
                  <Button
                    startIcon={<EmailIcon />}
                    variant="outlined"
                    color="primary"
                    fullWidth
                    onClick={() => applyViaEmail(role)}
                    sx={{ textTransform: 'none' }}
                  >
                    Email
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
